import type { FavoriteListDto, ProductListItemDto } from '@/services/platform/api/model';
import { ProductFavoriteToggle } from '../../../wishlist/ui/ProductFavoriteToggle';
import { ProductCardMedia, ProductCardInfo } from '../../ui/ProductCardMedia';

function ShopProductListProductCard({
  product,
  locale,
  onProductClick,
  favoriteLists,
  favoriteListGuidByProductId,
  refetchFavoriteIndex,
}: {
  product: ProductListItemDto;
  locale: string;
  onProductClick: () => void;
  favoriteLists: FavoriteListDto[];
  favoriteListGuidByProductId: Map<string, string>;
  refetchFavoriteIndex: () => Promise<void>;
}) {
  return (
    <div className="flex cursor-pointer flex-col items-start gap-2" onClick={onProductClick}>
      <ProductCardMedia
        imageUrl={product.imageUrl ?? undefined}
        alt={product.title ?? ''}
        soldOut={product.soldOut}
      />
      <div className="flex min-h-px w-full flex-1 items-start gap-2">
        <ProductCardInfo
          vendor={product.vendor}
          title={product.title}
          price={product.price ?? undefined}
          locale={locale}
        />
        <ProductFavoriteToggle
          product={{
            publicGuid: product.publicGuid,
            title: product.title,
            vendor: product.vendor,
            imageUrl: product.imageUrl,
          }}
          favoriteLists={favoriteLists}
          refetchFavoriteLists={refetchFavoriteIndex}
          favoriteListGuid={
            product.publicGuid ? favoriteListGuidByProductId.get(product.publicGuid) : undefined
          }
          onRefetchNeeded={refetchFavoriteIndex}
          size={18}
          className="mt-1 shrink-0"
        />
      </div>
    </div>
  );
}

export function ShopProductListView2Grid({
  products,
  locale,
  onProductClick,
  favoriteLists,
  favoriteListGuidByProductId,
  refetchFavoriteIndex,
}: {
  products: ProductListItemDto[];
  locale: string;
  onProductClick: (publicGuid: string | undefined) => void;
  favoriteLists: FavoriteListDto[];
  favoriteListGuidByProductId: Map<string, string>;
  refetchFavoriteIndex: () => Promise<void>;
}) {
  return (
    <div className="grid grid-cols-2 items-start gap-x-2 gap-y-[43px] px-4 pt-8">
      {products.map(p => (
        <ShopProductListProductCard
          key={p.publicGuid}
          product={p}
          locale={locale}
          onProductClick={() => onProductClick(p.publicGuid)}
          favoriteLists={favoriteLists}
          favoriteListGuidByProductId={favoriteListGuidByProductId}
          refetchFavoriteIndex={refetchFavoriteIndex}
        />
      ))}
    </div>
  );
}
